import {
  ActionTakenType,
  DocumentTemplateType,
  WorkflowStatusType,
} from '../../api-client/autogenerated';
import { DisabledActionTakenTypes, isActionTakenEnabled } from '../../scripts/action-taken-labels';
import { ActionCenterPrefill } from './action-center-prefill';

/**
 * What the review form takes from a prefill. It only decides the values to put in the form's own
 * fields; submitting stays the Architect's act, so nothing here (or in the caller) submits.
 */

export const REPLACE_RESPONSE_PROMPT = "Replace your response with CENTERLINE AI's?";

export interface PrefillPlan {
  comment: string;
  /** Only for a submittal, and only when the subscriber still offers the action. */
  actionTaken?: ActionTakenType;
}

export function planPrefill(args: {
  prefill: ActionCenterPrefill;
  workflowStatus: WorkflowStatusType | null | undefined;
  isTask: boolean;
  isPackage: boolean;
  isRfi: boolean;
  isWcpr: boolean;
  /** What is already typed in the form. */
  currentComment: string;
  /** Asked only when `currentComment` has text. */
  confirmReplace(): boolean;
  disabledActionTaken: DisabledActionTakenTypes;
  docType: DocumentTemplateType | null | undefined;
}): PrefillPlan | null {
  const { prefill } = args;
  const reviewable =
    !args.isTask &&
    !args.isPackage &&
    (args.workflowStatus === WorkflowStatusType.UnderReview ||
      args.workflowStatus === WorkflowStatusType.ArchitectUploaded);
  if (!reviewable) return null;
  if (args.currentComment.trim() && !args.confirmReplace()) return null;
  const takesAction = !args.isRfi && !args.isWcpr;
  return {
    comment: prefill.comment,
    ...(takesAction &&
    prefill.actionTaken &&
    isActionTakenEnabled(prefill.actionTaken, args.disabledActionTaken, args.docType)
      ? { actionTaken: prefill.actionTaken }
      : {}),
  };
}
